//Creates new Tip Box and assigns ID and type
export const createTrash = (data) => {
    //data = {id, type}
    return { type: "CREATE_TRASH", payload: data}
}

//Change tip attached status
export const trashOpen = (data) => {
    //data = {id, open}
    return { type: "TRASH_OPEN", payload: data}
}
